// extracted by mini-css-extract-plugin
export var orderSummary = "_te-0";
export var showMoreLessButton = "_te-1";